// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3QRJU","question":"Question_question__1FqrE","description":"Question_description__20e8Z"};